module.exports = __webpack_public_path__ + "img/9788994965529.7e98bbf1.jpg";